export default __webpack_public_path__ + "static/media/antp_ingvehicular_Abimael_Movil.ab8b3029.jpg";